/* global axios */

import ApiClient from './ApiClient';

class DigitalAcceptanceContractsAPI extends ApiClient {
  constructor(contactId) {
    super(`contacts/${contactId}/digital_acceptance_contracts`, { accountScoped: true });
    this.contactId = contactId;
  }

  createContract(contractData) {
    return axios.post(this.url, contractData);
  }

  getContract(contractId) {
    return axios.get(`${this.url}/${contractId}`);
  }

  listContracts() {
    return axios.get(this.url);
  }

  getTemplates(companyId) {
    return axios.get(`${this.url}/templates`, {
      params: { company_id: companyId },
    });
  }

  checkTemplateUsage(templateId, schoolEnrollmentId) {
    return axios.get(`${this.url}/check_template_usage`, {
      params: {
        template_id: templateId,
        school_enrollment_id: schoolEnrollmentId,
      },
    });
  }

  checkEnrollmentEditStatus(schoolEnrollmentId) {
    return axios.get(`${this.url}/check_enrollment_edit_status`, {
      params: {
        school_enrollment_id: schoolEnrollmentId,
      },
    });
  }

  syncContractStatus(contractId) {
    return axios.post(`${this.url}/${contractId}/sync_contract_status`, {
      contract_id: contractId,
    });
  }

  regenerateContract(enrollmentId) {
    return axios.post(`${this.url}/regenerate_contract`, {
      school_enrollment_id: enrollmentId,
    });
  }

  static forContact(contactId) {
    return new DigitalAcceptanceContractsAPI(contactId);
  }
}

export default DigitalAcceptanceContractsAPI;
